import { ActionReducerMap } from '@ngrx/store';
import * as models from '../store/models/store.models';
import * as fromReducer from './reducers/';

export interface AppState {
    auth: models.AuthState;
    prestadores: models.PrestadoresState;
    financiadores: models.FinanciadoresState;
    softwares: models.SoftwaresState;
    lugaresAtencion: models.LugaresAtencionState;
    transacciones: models.TransaccionesState;
    reclamos: models.ReclamosState;
    emailData: models.EmailDataState;
}

export const appReducers: ActionReducerMap<AppState, any> = {
    auth: fromReducer.authReducer,
    prestadores: fromReducer.prestadoresReducer,
    financiadores: fromReducer.financiadoresReducer,
    softwares: fromReducer.softwaresReducer,
    lugaresAtencion: fromReducer.lugaresAtencionReducer,
    transacciones: fromReducer.transaccionesStateReducer,
    reclamos: fromReducer.reclamosStateReducer,
    emailData: fromReducer.emailSenderStateReducer,
};
